import { createSlice } from "@reduxjs/toolkit";

// Utility Service
import { getToken, getUser, getTheme } from "../utils/auth";

const initialState = {
    token: getToken(),
    user: getUser(),
    theme: getTheme() || "light",
    recoveryCode: null,
    recoveryCodeModal: false,
    invoicePdfLoading: false
};

export const userSlice = createSlice({
    name: "User",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setTheme: (state, action) => {
            state.theme = action.payload;
        },
        setRecoveryCode: (state, action) => {
            state.recoveryCode = action.payload;
        },
        setRecoveryCodeModal: (state, action) => {
            state.recoveryCodeModal = action.payload;
        },
        setInvoicePdfLoading: (state, action) => {
            state.invoicePdfLoading = action.payload;
        }
    }
});

export const {
    setToken,
    setUser,
    setTheme,
    setRecoveryCode,
    setRecoveryCodeModal,
    setInvoicePdfLoading
} = userSlice.actions;

export const selectToken = (state) => state.user.token;
export const selectUser = (state) => state.user.user;
export const selectTheme = (state) => state.user.theme;
export const selectRecoveryCode = (state) => state.user.recoveryCode;
export const selectRecoveryCodeModal = (state) => state.user.recoveryCodeModal;
export const selectInvoicePdfLoading = (state) => state.user.invoicePdfLoading;

export default userSlice.reducer;